const ItemCategoryGroup = Object.freeze({
  FUNERAL: 'FUN',
  OTHERS: 'OTH',
  EXTERNAL_SERVICES: 'EXT',
  FLOWERS: 'FLO',
  PRINTS: 'PRI'
})

export default ItemCategoryGroup
